import { getWpAjaxEnv } from './env';
import { useConfig } from '../components/ConfigContext';
import { getCroppedImg } from '../utils/crop';
import { beforeCartUploadCropped, onFileChange } from './filesHandling';
import { data } from 'autoprefixer';

// samostatné funkce – lze použít i mimo React, tady ukázka s window:
export async function uploadToWpAjax(file) {
  const { ajaxurl, nonce } = getWpAjaxEnv();
  const formData = new FormData();
  formData.append('action', 'gbc_upload_image');
  formData.append('nonce', nonce);
  formData.append('file', file);

  const res = await fetch(ajaxurl, {
    method: 'POST',
    body: formData,
    credentials: 'same-origin',
  });
  const data = await res.json();
  if (data?.success) {
    return `${window.location.origin}/wp-content/uploads/gbc_uploads/${data.data.filename}`;
  }
  alert('Chyba při nahrávání obrázku.');
  return null;
}

// React-friendly volání košíku:
export const handleAddToCart = async (dataToCart) => {
  console.log(dataToCart);

  // const saveCropped = getCroppedImg(
  //   dataToCart.general.imageSrc,
  //   dataToCart.general.croppedAreaPixels
  // );
  //
  // let croppedUrl = null;
  // if (saveCropped) {
  //   await beforeCartUploadCropped(saveCropped).then((t) => (croppedUrl = t));
  //   dataToCart = { ...dataToCart, croppedUrl };
  // }

  const nonce = window.GBCONF?.nonce || '';
  const ajaxurl = window.GBCONF?.ajaxurl || '';
  // Sestav JSON s konfigurací (všechny aktuální stavy)
  const response = await fetch(ajaxurl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: `action=gbc_add_to_cart&nonce=${nonce}&config=${encodeURIComponent(
      JSON.stringify(dataToCart)
    )}`,
    credentials: 'same-origin',
  });
  const result = await response.json();
  if (result.success) {
    window.location.href = '/cart'; // nebo aktualizuj UI
  } else {
    alert('Nepodařilo se přidat do košíku.');
  }
};

export const handleUpdate = async (dataToCart, cartKey) => {
  const nonce = window.GBCONF?.nonce || '';
  const formData = new FormData();
  formData.append('action', 'gbc_update_cart_item');
  formData.append('nonce', nonce);
  formData.append('cart_key', cartKey || '');
  formData.append('config', JSON.stringify(dataToCart));

  const response = await fetch(window.GBCONF.ajaxurl, {
    method: 'POST',
    body: formData,
  });

  const result = await response.json();
  if (result.success) {
    // Přesměruj zpět do košíku
    window.location.href = '/cart';
  } else {
    console.error('Chyba při ukládání:', result.data);
  }
};
